import { useMatches } from 'react-router';

/**
 * This component is used to render sub navigation items for the current route.
 * Defined in the `subNavigationItems` property of the route handle.
 */
export function RouteSubNavigationItems() {
  const matches = useMatches();

  return <> {matches
    .filter(
      (match) =>
        match.handle && (match.handle as any).subNavigationItems
    )
    .map(match => (
      <div key={match.id}>
        {(match.handle as any).subNavigationItems()}
      </div>
    ))}
  </>
}